// Centralised route constants for the treasury deposit-requests
// (recharge) module. Backend route renames are a one-file change.

const DEPOSIT_REQUESTS = '/api/admin/treasury/deposit-requests'

export const DEPOSIT_REQUESTS_ENDPOINT_PATHS = {
  LIST: DEPOSIT_REQUESTS,
  STATUS_COUNTS: `${DEPOSIT_REQUESTS}/status-counts`,
  DETAIL: (id: string) => `${DEPOSIT_REQUESTS}/${id}`,
  APPROVE: (id: string) => `${DEPOSIT_REQUESTS}/${id}/approve`,
  REJECT: (id: string) => `${DEPOSIT_REQUESTS}/${id}/reject`,
} as const
